import { Box } from '@mui/material';
import { formatPrice } from '../../../utils/priceUtils';

/**
 * A coupon's price as the guest reads it: the price before it struck through, then what they pay.
 * Takes the colour and size of the text it sits in, so it fits a summary box, a card or a sentence.
 * Funnel-only, like the rest of `features/booking`: the dashboard has its own neutral rendering.
 */
const DiscountedPrice = ({ price, originalPrice }) => (
  <Box component="span" data-testid="discounted-price">
    <Box component="s" sx={{ opacity: 0.6, mr: 1 }} data-testid="original-price">
      {formatPrice(originalPrice)}
    </Box>
    <Box component="strong" data-testid="final-price">{formatPrice(price)}</Box>
  </Box>
);

export default DiscountedPrice;
